import pages from './pages';
import services from './services';
import ui from './ui';

export default {
  pages,
  services,
  ui,
};
